import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import PropTypes from 'prop-types';

import { gettext } from '@eventbrite/i18n';
import { CrossChunky as CrossChunkySvg } from '@eb/eds-iconography';
import { IconButton } from '@eb/eds-icon-button';

import FilterButton from './FilterButton';
import { getSearchContent, getSearchSection } from '../../../../utils/general';

//TODO: Figure out best way to handle the "smart" behavior here
import { handleRemoveFilter as handleRemoveFilterAction } from '../../../../redux/actions/search';

const HashCFilterButton = (props) => {
    useEffect(() => {
        // Reset the search for the user if empty state, temporary UX workaround
        if (props.isEmpty) {
            props.handleRemoveFilter({ hash: true });
        }
    });

    return (
        <li className="filter-panel__drawers__item eds-l-pad-top-6 eds-l-pad-bot-5">
            <FilterButton
                isActive={true}
                onClick={() => null}
                value="creditsForOrganizerFilter"
            >
                <div>
                    <div className="filter-panel__drawers__item__sub-header">
                        {gettext('Showing events similar to')}
                    </div>
                    <div className="filter-panel__drawers__item__header">
                        {props.nameOfFirstEvent}
                    </div>
                </div>
            </FilterButton>
            <div className="filter-panel__drawers__item--close-btn">
                <IconButton
                    title={gettext('Remove filter')}
                    iconType={<CrossChunkySvg />}
                    iconColor="ui-blue"
                    onClick={() => props.handleRemoveFilter({ hash: true })}
                />
            </div>
        </li>
    );
};

HashCFilterButton.propTypes = {
    handleRemoveFilter: PropTypes.func,
};

const mapStateToProps = (state) => {
    const section = getSearchSection(state.location.isOnline);
    const content = getSearchContent(
        state.content.entities,
        state.pagination,
        state.currencyFormat,
        section,
    );

    const eventContent = content.find(({ type }) => type === 'event');
    const eventResults = eventContent?.content || [];
    const nameOfFirstEvent =
        eventResults && eventResults[0]
            ? eventResults[0].name
            : gettext('This event');

    return {
        nameOfFirstEvent,
        isEmpty: !eventResults.length,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    handleRemoveFilter: (...args) =>
        dispatch(handleRemoveFilterAction(ownProps.history, ...args)),
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(HashCFilterButton);
